import { axios } from 'lib'
import { useMutation, useQueryClient } from 'react-query'
import { toast } from 'react-toastify'

const createMaximumMaterialDiscountByGroup = async (
  data: any
): Promise<any> => {
  return await axios.post('/parameters/discount-max-mat-group', data)
}

export function useCreateMaximumMaterialDiscountByGroup() {
  const queryClient = useQueryClient()

  return useMutation(createMaximumMaterialDiscountByGroup, {
    onSuccess: () => {
      queryClient.invalidateQueries('maximumMaterialDiscountByGroup')
      toast.success('Alçada de desconto adicionado com sucesso!')
    },
    onError: (error: unknown) => {
      console.error(error)
      toast.error('Não foi possível adicionar alçada de desconto!')
    }
  })
}
